import { render, staticRenderFns } from "./Invoices.vue?vue&type=template&id=38f2b6f3&scoped=true"
import script from "./Invoices.vue?vue&type=script&lang=js"
export * from "./Invoices.vue?vue&type=script&lang=js"
import style0 from "./Invoices.vue?vue&type=style&index=0&id=38f2b6f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f2b6f3",
  null
  
)

export default component.exports